// HKDSE 十二篇範文原文數據
export const hkdseOriginalTexts = {
  // A1. 孟子《魚我所欲也》
  'hkdse-a1-mengzi-fish': {
    id: 'hkdse-a1-mengzi-fish',
    title: '孟子《魚我所欲也》',
    author: '孟子',
    dynasty: '戰國',
    originalText: `孟子曰：「魚，我所欲也，熊掌，亦我所欲也；二者不可得兼，舍魚而取熊掌者也。生亦我所欲也，義亦我所欲也；二者不可得兼，舍生而取義者也。生亦我所欲，所欲有甚於生者，故不為苟得也；死亦我所惡，所惡有甚於死者，故患有所不辟也。如使人之所欲莫甚於生，則凡可以得生者，何不用也？使人之所惡莫甚於死者，則凡可以辟患者，何不為也？由是則生而有不用也，由是則可以辟患而有不為也，是故所欲有甚於生者，所惡有甚於死者。非獨賢者有是心也，人皆有之，賢者能勿喪耳。

一簞食，一豆羹，得之則生，弗得則死。嘑爾而與之，行道之人弗受；蹴爾而與之，乞人不屑也；萬鍾則不辯禮義而受之。萬鍾於我何加焉？為宮室之美、妻妾之奉、所識窮乏者得我與？鄉為身死而不受，今為宮室之美為之；鄉為身死而不受，今為妻妾之奉為之；鄉為身死而不受，今為所識窮乏者得我而為之，是亦不可以已乎？此之謂失其本心。」`,
    modernTranslation: `孟子說：「魚，是我想要的；熊掌，也是我想要的。如果兩者不能同時擁有，我就捨棄魚而選擇熊掌。生命，也是我想要的；大義，也是我想要的。如果兩者不能同時擁有，我就捨棄生命而選擇大義。

生命是我想要的，然而我想要的東西還有比生命更為重要的，所以我不會苟且偷生。死亡是我厭惡的，然而我厭惡的事情還有比死亡更討厭的，所以有的禍害我就不躲避。如果人們喜愛的東西沒有比生命更重要的，那麼凡是可求得生存的方法，為甚麼不使用呢？如果人們厭惡的事情沒有被死亡更討厭的，那麼凡是可以躲避禍害的手段，為甚麼不去做呢？憑這些方法就可以生存，有人卻不用；憑這些方法就可以躲避禍患，有人卻不願意這樣做。

因此（可以證明）人們所想要的東西有比生命更重要的，人們厭惡的事情有比死亡更討厭的。不僅僅賢人有這種本性，人人都有這種本性，只不過賢人能夠保存這種本性不喪失罷了。

一筐飯，一碗湯，得到便可以活下去，失去它就要死亡。呼喝着把食物給人吃，流浪者不會接受；踐踏後給人吃，乞丐也不屑接受；為了優厚的俸祿，不分辨是否合於禮義就接受。

這優厚的俸祿對我有甚麼好處呢？為了住宅的華美、妻妾的侍奉，為了我認識的貧困者得到我的恩惠並感激我嗎？對於這些不合禮義的東西過去寧願犧牲自己的生命都不接受，現在卻為了華美的居室而接受了；過去寧願犧牲自己的生命都不接受，現在卻為了妻妾的侍奉而接受了；以往寧願犧牲自己的生命都不接受，現在卻為了我所認識的貧困者感激我而接受了，這些做法不能停止嗎？這就是說喪失了人的本性。」`
  },

  // A2. 荀子《勸學》（節錄）
  'hkdse-a2-xunzi-learning': {
    id: 'hkdse-a2-xunzi-learning',
    title: '荀子《勸學》（節錄）',
    author: '荀子',
    dynasty: '戰國',
    originalText: `君子曰：學不可以已。青，取之於藍，而青於藍；冰，水為之，而寒於水。木直中繩，輮以為輪，其曲中規；雖有槁暴，不復挺者，輮使之然也。故木受繩則直，金就礪則利，君子博學而日參省乎己，則知明而行無過矣。

吾嘗終日而思矣，不如須臾之所學也；吾嘗跂而望矣，不如登高之博見也。登高而招，臂非加長也，而見者遠。順風而呼，聲非加疾也，而聞者彰。假輿馬者，非利足也，而致千里；假舟楫者，非能水也，而絕江河。君子生非異也，善假於物也。

積土成山，風雨興焉；積水成淵，蛟龍生焉；積善成德，而神明自得，聖心備焉。故不積跬步，無以至千里；不積小流，無以成江海。騏驥一躍，不能十步；駑馬十駕，功在不舍。鍥而舍之，朽木不折；鍥而不舍，金石可鏤。螾無爪牙之利，筋骨之強，上食埃土，下飲黃泉，用心一也。蟹六跪而二螯，非蛇蟺之穴無可寄託者，用心躁也。`,
    modernTranslation: `君子說：求學是不可以停止的。青這種顏色是由藍草提煉出來的，卻比藍草更青；冰是由水凝結而成的，卻比水更冷。木材挺直得合於繩墨的標準，經過火烤加工製成車輪，它彎曲的程度便合於圓規的標準，即使再度將它火烘、曝曬，也不會回復挺直，這是輮曲的工夫使它變成這個樣子。所以木材經過繩墨矯正就會筆直，刀劍經過磨礪就會鋒利；君子廣泛學習不同知識，而且每天再三反省自身言行，就能智慧高明，行為沒有過失了。

我曾經整天深思，卻不如片刻時間的學習得到的多；我曾經提起腳跟望向遠方，卻不如登上高處看得廣闊。登上高處招手，手臂並沒增長，卻能讓更遠的人看到；順著風呼叫，聲音並無特別宏亮，而卻能讓人聽得更清楚。乘駕車馬的人，並不是善於行走，卻能夠遠行千里；搭乘舟船的人，並不是善於游水，卻能橫渡江河。君子天性和一般人沒有什麼不同，只是善於利用後天所學罷了。

累積泥土成為高山，自然就會興起風雨；累積流水而成為深淵，自然就會生出蛟龍；累積善行而養成美德，自然就會達到心智澄明的境界，具備聖人的修養。所以不一步一步的累積，是無法到達千里之遠的；不匯聚一條一條的小水流，就無法成為江海。駿馬一個跳躍，不能跳出十步遠；劣馬連走十天的行程，也能到達千里，牠的成功在於牠不放棄。雕刻時若半途而廢，就是已經朽爛的木頭也無法折斷；假若持之以恆，就是金屬石頭也可加以雕飾。蚯蚓沒有銳利的爪牙，沒有強勁的筋骨，卻可以往上鑽食土壤，往下啜飲地泉，因為牠用心專一。螃蟹雖然有六隻腳兩隻大鉗子，但沒有蛇或鱔的洞穴，就無處藏身了，這是因為牠心思浮躁的緣故。`
  },

  // A3. 蘇洵《六國論》
  'hkdse-a3-suxun-sixstates': {
    id: 'hkdse-a3-suxun-sixstates',
    title: '蘇洵《六國論》',
    author: '蘇洵',
    dynasty: '宋',
    originalText: `六國破滅，非兵不利，戰不善，弊在賂秦。賂秦而力虧，破滅之道也。或曰：「六國互喪，率賂秦耶？」曰：「不賂者以賂者喪。」蓋失強援，不能獨完，故曰「弊在賂秦」也。

秦以攻取之外，小則獲邑，大則得城，較秦之所得與戰勝而得者，其實百倍；諸侯之所亡與戰敗而亡者，其實亦百倍。則秦之所大欲，諸侯之所大患，固不在戰矣。思厥先祖父，暴霜露，斬荊棘，以有尺寸之地。子孫視之不甚惜，舉以予人，如棄草芥。今日割五城，明日割十城，然後得一夕安寢；起視四境，而秦兵又至矣。然則諸侯之地有限，暴秦之欲無厭，奉之彌繁，侵之愈急，故不戰而強弱勝負已判矣。至於顛覆，理固宜然。古人云：「以地事秦，猶抱薪救火，薪不盡，火不滅。」此言得之。

齊人未嘗賂秦，終繼五國遷滅，何哉？與嬴而不助五國也。五國既喪，齊亦不免矣。燕趙之君，始有遠略，能守其土，義不賂秦。是故燕雖小國而後亡，斯用兵之效也。至丹以荊卿為計，始速禍焉。趙嘗五戰于秦，二敗而三勝；後秦擊趙者再，李牧連卻之；洎牧以讒誅，邯鄲為郡，惜其用武而不終也。且燕趙處秦革滅殆盡之際，可謂智力孤危，戰敗而亡，誠不得已。向使三國各愛其地，齊人勿附於秦，刺客不行，良將猶在，則勝負之數，存亡之理，當與秦相較，或未易量。

嗚呼！以賂秦之地，封天下之謀臣；以事秦之心，禮天下之奇才；并力西嚮，則吾恐秦人食之不得下嚥也。悲夫！有如此之勢，而為秦人積威之所劫，日削月割，以趨於亡！為國者無使為積威之所劫哉！

夫六國與秦皆諸侯，其勢弱於秦，而猶有可以不賂而勝之之勢；茍以天下之大，而從六國破亡之故事，是又在六國下矣！`,
    modernTranslation: `六個諸侯國的滅亡，不是（因為他們的）武器不鋒利，仗打得不好，弊病在於（用土地來）賄賂秦國。（用土地）賄賂秦國而（自己的）國力被損耗，（這就）是滅亡的原因。有人說：「六國交接地滅亡，（難道）都是因為賄賂秦國嗎？」（回答）說：「不賄賂秦國的國家因為有賄賂秦國的國家而滅亡。原因是（不賄賂秦國的國家）失去強大的援助，不能獨自保全，所以說：「弊病在於賄賂秦國」。

秦國除了藉戰爭奪取土地以外，（還受到諸侯的賄賂），（收穫）小的就獲得邑鎮，（收穫）大的就獲得城池，比較秦國（受賄賂）所得到的土地與戰勝別國所得到的土地，（前者）實際多百倍；六國諸侯（賄賂秦國）所喪失的土地與戰敗所喪失的土地（相比），（前者）實際也要多百倍。那麼秦國最想要的，與六國諸侯最擔心的，本來就不在於戰爭。想到他們的祖輩和父輩，暴露於寒霜雨露（之下），披荊斬棘，才有了很少的一點土地。子孫對那些土地卻不很愛惜，全都拿來送給別人，就像扔掉小草一樣（不珍惜）。今天捨棄五座城，明天捨棄十座城，然後能睡一夜安穩覺；（翌日）起牀一看四周邊境，秦國的軍隊又來了。既然這樣，那麼諸侯的土地有限，強暴的秦國的慾望不會滿足，（諸侯）送給他的土地越多，他侵犯諸侯國土就越急迫，所以用不着戰爭，誰強誰弱，誰勝誰負已經分明了。到了覆滅的地步，道理本來應當這樣。古人說：「用土地侍奉秦國，好像抱著柴救火，柴不燒完，火就不會滅。」這話說出其中道理。

齊國不曾賄賂秦國，（可是）最終也隨着五國滅亡，為什麼呢？（是因為齊國）跟秦國交好卻不幫助其他五國。五國已經滅亡，齊國也沒法幸免了。燕國和趙國的國君，起初有長遠的謀略，能夠守住他們的國土，以不賄賂秦國為原則。因此燕雖然是個小國，卻後來才滅亡，這就是作戰抗秦的效果。等到燕太子丹用（派遣）荊軻（刺殺秦王）作（對付秦國的）計策，才招致（滅亡的）禍患。趙國曾經與秦國交戰五次，打了兩次敗仗、三次勝仗；後來秦國兩次攻打趙國。（趙國大將）李牧接連擊退秦軍；等到李牧因（他人的）讒言而被誅殺，（趙國都城）邯鄲變成（秦國的一個）郡，可惜趙國用武力（抗秦）卻沒有（堅持）到底。而且燕趙兩國處在秦國把其他國家快要消滅乾淨的時候，可以說是智謀與勇力都處孤立艱危（的狀態），戰敗了而亡國，確實是無可奈何的事。假使韓、魏、楚三國都愛惜他們的國土，齊國不依附秦國。（燕國）不用刺客（刺秦王之計），（趙國的）良將李牧仍然活着，那麼勝敗的命運，存亡的理數，倘若和秦國相互比較，也許（還）不容易衡量（出高低）。

唉！（如果六國諸侯）用賄賂秦國的土地，分封給天下間有謀略的臣子；用侍奉秦國的心，禮遇天下間才智出眾的人；合力向西（對付秦國），那麼，我恐怕秦國人飯也不能嚥下去。真可悲啊！有這樣的（有利）形勢，卻被秦國久積的威勢所威脅，天天割地，月月割地，以至於走向滅亡！治理國家的人無須被久積的威勢所威脅啊！

六國和秦國都是諸侯之國，六國的勢力比秦國弱，卻仍然有可以不賄賂秦國而戰勝它的優勢；如果憑藉偌大的國家，卻追隨六國滅亡的前例，這就比不上六國了！`
  },

  // A4. 莊子《逍遙遊》
  'hkdse-a4-zhuangzi-freedom': {
    id: 'hkdse-a4-zhuangzi-freedom',
    title: '莊子《逍遙遊》',
    author: '莊子',
    dynasty: '戰國',
    originalText: `惠子謂莊子曰：「魏王貽我大瓠之種，我樹之成而實五石。以盛水漿，其堅不能自舉也。剖之以為瓢，則瓠落無所容。非不呺然大也，吾為其無用而掊之。」莊子曰：「夫子固拙於用大矣！宋人有善為不龜手之藥者，世世以洴澼絖為事。客聞之，請買其方百金。聚族而謀曰：『我世世為洴澼絖，不過數金；今一朝而鬻技百金，請與之。』客得之，以說吳王。越有難，吳王使之將，冬與越人水戰，大敗越人，裂地而封之。能不龜手一也；或以封，或不免於洴澼絖，則所用之異也。今子有五石之瓠，何不慮以為大樽而浮於江湖，而憂其瓠落無所容，則夫子猶有蓬之心也夫！」

惠子謂莊子曰：「吾有大樹，人謂之樗；其大本擁腫而不中繩墨，其小枝卷曲而不中規矩。立之塗，匠者不顧。今子之言，大而無用，衆所同去也。」莊子曰：「子獨不見狸狌乎？卑身而伏，以候敖者；東西跳梁，不辟高下，中於機辟，死於罔罟。今夫斄牛，其大若垂天之雲；此能為大矣，而不能執鼠。今子有大樹，患其無用，何不樹之於無何有之鄉，廣莫之野，彷徨乎無為其側，逍遙乎寢臥其下，不夭斤斧，物無害者。無所可用，安所困苦哉？」`,
    modernTranslation: `惠子對莊子說：「魏王送我大葫蘆的種子，我種植它成長，果實足有五石之大；用它來盛水，它的堅固程度卻不能承受起自身的重量；剖開它為瓢，則瓢大而無處可容。這葫蘆不是不大，但我認為它沒有用處，就把它打破了。」莊子說：「你實在不善於用『大』啊！有個宋國人善於製造不龜裂手的秘藥，他家世世代代都以漂洗絲絮為事業。有個客人聽聞此事，願出百金來買他的藥方。於是他便聚合家人商議說：『我們世世代代漂洗絲絮，只不過得到數金；如今一旦賣出這個藥方就可獲得百金，就賣了吧。』客人得到了藥方，便去遊說吳王。這時越國又來侵吳，吳王就派他將兵，在冬天與越軍水戰，結果大敗越軍，便割地封賞他。同樣一個不龜裂手的藥方，有人因此得到封賞，有人卻只用來漂洗絲絮，那就是所用方法的不同啊。如今你有五石容量的大葫蘆，為何不考慮將它當腰舟而浮游於江湖之上，反而擔憂它太大而無處可容呢？可見你的心還是茅塞不通啊！」

惠子對莊子說：「我有一棵大樹，人家都叫它臭椿樹。它的樹幹臃腫而不合墨線，它的小枝彎曲而不合規矩，長在路邊，木匠也不會回首一看。現在你的言論，大而無用，大家都會離棄啊。」莊子說：「你難道沒見過野貓和黃鼠狼嗎？牠們卑伏身子，等待出遊的小動物；東跳西躍，不避高低，往往踏中機關，死於網中。再看看那牦牛，身體大得像天邊的雲，牠的功能是很大，但卻連捕鼠也不能。現在你有這麼一棵大樹，還愁它沒有用處，為何不把它種在寬曠無人的鄉間、廣闊無邊的原野，寫意無憂地在樹旁閑逛，優遊自得地在樹下躺臥？它不會受斧頭砍伐，又沒有東西來毀害它，沒有用處，又有甚麼困苦呢？」`
  },

  // A5. 韓愈《師說》
  'hkdse-a5-hanyu-teacher': {
    id: 'hkdse-a5-hanyu-teacher',
    title: '韓愈《師說》',
    author: '韓愈',
    dynasty: '唐',
    originalText: `古之學者必有師。師者，所以傳道、受業、解惑也。人非生而知之者，孰能無惑？惑而不從師，其為惑也終不解矣。

生乎吾前，其聞道也，固先乎吾，吾從而師之；生乎吾後，其聞道也，亦先乎吾，吾從而師之。吾師道也，夫庸知其年之先後生於吾乎？是故無貴無賤，無長無少，道之所存，師之所存也。

嗟乎！師道之不傳也久矣！欲人之無惑也難矣！古之聖人，其出人也遠矣，猶且從師而問焉；今之眾人，其下聖人也亦遠矣，而恥學於師；是故聖益聖，愚益愚，聖人之所以為聖，愚人之所以為愚，其皆出於此乎！

愛其子，擇師而教之，於其身也則恥師焉，惑矣！彼童子之師，授之書而習其句讀者，非吾所謂傳其道、解其惑者也。句讀之不知，惑之不解，或師焉，或不焉，小學而大遺，吾未見其明也。

巫、醫、樂師、百工之人，不恥相師；士大夫之族，曰師、曰弟子云者，則羣聚而笑之。問之，則曰：「彼與彼年相若也，道相似也。」位卑則足羞，官盛則近諛。嗚呼！師道之不復，可知矣。巫、醫、樂師、百工之人，君子不齒，今其智乃反不能及，其可怪也歟！

聖人無常師，孔子師郯子、萇弘、師襄、老聃。郯子之徒，其賢不及孔子。孔子曰：「三人行，則必有我師。」是故弟子不必不如師，師不必賢於弟子；聞道有先後，術業有專攻，如是而已。

李氏子蟠，年十七，好古文，六藝經傳，皆通習之；不拘於時，學於余。余嘉其能行古道，作《師說》以貽之。`,
    modernTranslation: `古代求學的人一定有老師。老師，是用來傳授道理，講授學業，解答疑難問題的。人不是一生下來就懂得知識和道理的，誰能沒有疑惑？有疑惑卻不求老師指教，那成為疑難的問題，終究不能解決。在我之前出生的人，他懂得知識和道理本來就比我早，我跟從他並以他為師；在我之後出生的人，（如果）他懂得知識和道理也比我早，我也跟從他學習並以他為師。我學習的是知識，哪管他的年齡比我大還是比我小呢？因此，無論地位顯貴或是低下，無論年長年少，知識所存在的地方，就是老師所存在的地方。

唉！從師求學的傳統已經失傳很久了，想要人們沒有疑惑很難吶！古代的聖人，他們超出一般人很遠了，尚且跟從老師向老師請教學問道理；現在的一般人，他們跟聖人相比相差很遠了，卻以向老師學習為羞恥。所以聖人就更加聖明，愚人就更加愚昧。聖人能成為聖人的原因，愚人能成為愚人的原因，大概就是出於這個緣故吧？

愛自己的孩子，選擇老師來教他。（但是）對於他自己，卻以跟從老師學習為可恥，糊塗啊！那些教他讀書，學習句子的停頓的老師，不是我所說的傳授道理、解答疑難問題的老師。不知道斷句要問老師，有疑惑不能解決卻不願問老師，小的方面（句讀）要學習，大的方面（解惑）卻丟棄，我沒見到他聰明在哪。

巫醫，樂師及各種工匠，不以互相學習為恥。士大夫這類人中，說起老師、弟子的時候，這些人就聚集在一起嘲笑他。問那些嘲笑者（嘲笑他的原因），他們就說："那個人與某人年齡相近，修養和學業也差不多，（怎麼能稱他為老師呢？）以地位低的人為師，足以感到羞愧，稱官位高的人為師就近於諂媚。"啊！從師學習的風尚不再恢復，由此就可以知道了。巫醫，奏樂之人，各類工匠，是士大夫們所看不起的，現在他們的見識反而比不上這些人了。真是令人奇怪啊!

聖人沒有固定的老師，孔子曾經以郯子、萇弘、師襄、老聃為師。郯子這一類人，他們的道德才能（當然）不如孔子。孔子說："多人同行，其中就一定有我的老師。"因此學生不一定不如老師，老師也不一定比弟子有賢能，懂得道理有先有後，學問和技藝上各有各的研究，只是像這樣罷了。李氏的兒子李蟠，年紀十七歲，愛好古文，六藝的經文和傳文都普遍學習了，不受世俗的限制，向我學習。我讚許他能履行古人從師學習的風尚，寫了這篇《師說》來送給他。`
  },

  // B1. 《論語》論仁
  'hkdse-b1-analects-ren': {
    id: 'hkdse-b1-analects-ren',
    title: '《論語》論仁',
    author: '孔子及其弟子',
    dynasty: '春秋',
    originalText: `（一）子曰：「不仁者，不可以久處約，不可以長處樂。仁者安仁，知者利仁。」(《里仁》第四)

（二）子曰：「富與貴，是人之所欲也；不以其道得之，不處也。貧與賤，是人之所惡也；不以其道得之，不去也。君子去仁，惡乎成名？君子無終食之間違仁，造次必於是，顛沛必於是。」(《里仁》第四)

（三）顏淵問仁。子曰：「克己復禮為仁。一日克己復禮，天下歸仁焉。為仁由己，而由人乎哉？」顏淵曰：「請問其目。」子曰：「非禮勿視，非禮勿聽，非禮勿言，非禮勿動。」顏淵曰：「回雖不敏，請事斯語矣。」(《顏淵》第十二)

（四）子曰：「志士仁人，無求生以害仁，有殺身以成仁。」(《衛靈公》第十五)`,
    modernTranslation: `（一）孔子說：「沒有仁德的人，不可以長期處於窮困的境況中，不可以長期處於安樂的境況中。有仁德的人安於實踐仁，有智慧的人藉着實踐仁德而得到利益。」（《里仁》第四）

（二）孔子說：「財富和顯貴，是人人都想得到的；不以正當的方法得到它們，不可以接受；貧窮和卑賤，是人人都厭惡的，不以正當的方法擺脫它們，不可以離去。君子拋棄了仁德，怎樣成就他的名聲？即使短至一頓飯的時間，君子也不會違背仁德，倉卒緊迫的時候必定如此，顛沛流離的時候也必如此。」（《里仁》第四）

（三）顏淵問甚麼是仁德。孔子說：「克制自己的私慾，使言行舉止合乎禮節，就是仁德。一旦能做到這一點，天下的人都會歸服你的仁德。實踐仁德全憑自己，難道是憑藉別人嗎？」顏淵說：「請問仁德包括甚麼條目？」孔子說：「不看不合乎禮節的東西，不聽不合乎禮節的說話，不說不合乎禮節的話語，不做不合乎禮節的事情。」顏淵說：「我雖然不聰敏，請讓我照着這些話去做。」（《顏淵》第十二）

（四）孔子說：「有節操的人和有仁德的人之中，沒有人會為求生存而損害仁德，只有犧牲自己的生命來成全仁德。」（《衞靈公》第十五）`
  },

  // B2. 《論語》論孝
  'hkdse-b2-analects-filial': {
    id: 'hkdse-b2-analects-filial',
    title: '《論語》論孝',
    author: '孔子及其弟子',
    dynasty: '春秋',
    originalText: `（五）孟懿子問孝。子曰：「無違。」樊遲御，子告之曰：「孟孫問孝於我，我對曰，無違。」樊遲曰：「何謂也？」子曰：「生事之以禮；死葬之以禮，祭之以禮。」（《為政》第二）

（六）子游問孝。子曰：「今之孝者，是謂能養。至於犬馬，皆能有養；不敬，何以別乎！」（《為政》第二）

（七）子曰：「事父母幾諫，見志不從，又敬不違，勞而不怨。」(《里仁》第四）

（八）子曰：「父母之年，不可不知也。一則以喜，一則以懼。」(《里仁》第四)`,
    modernTranslation: `（五）孟懿子問如何是孝。孔子曰：「不要違背禮節。」樊遲替孔子駕車，孔子告訴他說：「孟孫問我盡孝之道，我回答說，不要違背禮節。」樊遲說：「這是甚麼意思呢？」孔子說：「父母健在時，依規定的禮節侍奉他們；父母去世，依規定的禮節安葬他們、祭祀他們。」（《為政》第二）

（六）孔子說：「現在所謂的孝子，只說能事奉供養父母。至於狗、馬，都能夠得到食物來飼養，如果對父母不敬，這跟飼養狗、馬有甚麼分別呢？」（《為政》第二）

（七）孔子說：「侍奉父母，如果父母有不對的地方，要婉言勸諫；看到自己的規勸沒有獲得父母接納，仍要恭敬地對待他們，不冒犯他們；因多次勸諫父母而勞苦，但不會怨恨。」(《里仁》第四)

（八）孔子說：「父母的年齡，不能夠不時時刻刻記掛心上。一方面因父母長壽而高興，一方面因父母年事已高而恐懼。」(《里仁》第四)`
  },

  // B3. 《論語》論君子
  'hkdse-b3-analects-gentleman': {
    id: 'hkdse-b3-analects-gentleman',
    title: '《論語》論君子',
    author: '孔子及其弟子',
    dynasty: '春秋',
    originalText: `（九）子曰：「君子不重則不威；學則不固。主忠信。無友不如己者。過則勿憚改。」(《學而》第一)

（十）子曰：「君子坦蕩蕩，小人長戚戚。」(《述而》第七)

（十一）司馬牛問君子。子曰：「君子不憂不懼。」曰：「不憂不懼，斯謂之君子矣乎？」子曰：「內省不疚，夫何憂何懼？」(《顏淵》第十二)

（十二）子曰：「君子成人之美，不成人之惡。小人反是。」(《顏淵》第十二)

（十三）子曰：「君子恥其言而過其行。」(《憲問》第十四)

（十四）子曰：「君子義以為質，禮以行之，孫以出之，信以成之。君子哉！」(《衛靈公》第十五)

（十五）子曰：「君子病無能焉，不病人之不己知也。」(《衛靈公》第十五)

（十六）子曰：「君子求諸己，小人求諸人。」(《衛靈公》第十五)`,
    modernTranslation: `（九）孔子說：「君子不穩重就不會有威嚴，學問也不會鞏固。自己注重忠信，交的朋友也如自己一樣忠信，有了過錯也不要害怕改過。」(《學而》第一)

（十）孔子說：「君子心胸坦然寬廣，小人經常憂愁恐懼。」(《述而》第七)

（十一）司馬牛問孔子，怎樣才是君子。孔子說：「君子沒有憂愁，也沒有恐懼。」司馬牛問：「不憂愁不恐懼，這就算是君子了嗎？」孔子又說：「自己內心能夠反省不愧於心，還有什麼憂愁有什麼恐懼呢？」(《顏淵》第十二)

（十二）孔子說：「君子會去成全別人的好事，但不會促成別人的壞事。小人則是相反。」(《顏淵》第十二)

（十三）孔子說：「君子對自己的言論超過自己的行為，感到羞恥。」(《憲問》第十四)

（十四）孔子說：「君子以道義為行事原則，行事依照禮節、說話謙遜、做事守信，這就是君子！」(《衛靈公》第十五)

（十五）孔子說：「君子擔憂的是自己沒有能力，而不擔憂別人不知道自己。」(《衛靈公》第十五)

（十六）孔子說：「君子要求的是自己，小人要求的是別人。」(《衛靈公》第十五)`
  },
  // C1. 司馬遷《廉頗藺相如列傳》
  'hkdse-c1-simaqian-lianpo-linxiangru': {
    id: 'hkdse-c1-simaqian-lianpo-linxiangru',
    title: '司馬遷《廉頗藺相如列傳》',
    author: '司馬遷',
    dynasty: '漢',
    category: 'C1',
    type: 'C',
    originalText: `廉頗者，趙之良將也。趙惠文王十六年，廉頗為趙將伐齊，大破之，取陽晉，拜為上卿，以勇氣聞於諸侯。藺相如者，趙人也，為趙宦者令繆賢舍人。

趙惠文王時，得楚和氏璧。秦昭王聞之，使人遺趙王書，願以十五城請易璧。趙王與大將軍廉頗諸大臣謀：欲予秦，秦城恐不可得，徒見欺；欲勿予，即患秦兵之來。計未定，求人可使報秦者，未得。

宦者令繆賢曰：「臣舍人藺相如可使。」王問：「何以知之？」對曰：「臣嘗有罪，竊計欲亡走燕，臣舍人相如止臣，曰：『君何以知燕王？』臣語曰：『臣嘗從大王與燕王會境上，燕王私握臣手，曰「願結友。」以此知之，故欲往。』相如謂臣曰：『夫趙彊而燕弱，而君幸於趙王，故燕王欲結於君。今君乃亡趙走燕，燕畏趙，其勢必不敢留君，而束君歸趙矣。君不如肉袒伏斧質請罪，則幸得脫矣。』臣從其計，大王亦幸赦臣。臣竊以為其人勇士，有智謀，宜可使。」

於是王召見，問藺相如曰：「秦王以十五城請易寡人之璧，可予不？」相如曰：「秦彊而趙弱，不可不許。」王曰：「取吾璧，不予我城，奈何？」相如曰：「秦以城求璧而趙不許，曲在趙；趙予璧而秦不予趙城，曲在秦。均之二策，寧許以負秦曲。」王曰：「誰可使者？」相如曰：「王必無人，臣願奉璧往使。城入趙而璧留秦；城不入，臣請完璧歸趙。」趙王於是遂遣相如奉璧西入秦。

秦王坐章台見相如，相如奉璧奏秦王。秦王大喜，傳以示美人及左右，左右皆呼萬歲。相如視秦王無意償趙城，乃前曰：「璧有瑕，請指示王。」王授璧，相如因持璧，卻立，倚柱，怒髮上衝冠，謂秦王曰：「大王欲得璧，使人發書至趙王，趙王悉召羣臣議，皆曰：『秦貪，負其彊，以空言求璧，償城恐不可得』。議不欲予秦璧。臣以為布衣之交尚不相欺，況大國乎！且以一璧之故逆彊秦之驩，不可。於是趙王乃齋戒五日，使臣奉璧，拜送書於庭。何者？嚴大國之威以修敬也。今臣至，大王見臣列觀，禮節甚倨；得璧，傳之美人，以戲弄臣。臣觀大王無意償趙王城邑，故臣復取璧。大王必欲急臣，臣頭今與璧俱碎於柱矣！」

相如持其璧睨柱，欲以擊柱。秦王恐其破璧，乃辭謝固請，召有司案圖，指從此以往十五都予趙。相如度秦王特以詐佯為予趙城，實不可得，乃謂秦王曰：「和氏璧，天下所共傳寶也。趙王恐，不敢不獻。趙王送璧時，齋戒五日，今大王亦宜齋戒五日，設九賓於廷，臣乃敢上璧。」秦王度之，終不可彊奪，遂許齋五日，舍相如廣成傳。相如度秦王雖齋，決負約不償城，乃使其從者衣褐，懷其璧，從徑道亡，歸璧於趙。

秦王齋五日後，乃設九賓禮於廷，引趙使者藺相如。相如至，謂秦王曰：「秦自繆公以來二十餘君，未嘗有堅明約束者也。臣誠恐見欺於王而負趙，故令人持璧歸，間至趙矣。且秦彊而趙弱，大王遣一介之使至趙，趙立奉璧來；今以秦之彊而先割十五都予趙，趙豈敢留璧而得罪於大王乎？臣知欺大王之罪當誅，臣請就湯鑊。唯大王與羣臣孰計議之！」

秦王與羣臣相視而嘻。左右或欲引相如去，秦王因曰：「今殺相如，終不能得璧也，而絕秦趙之驩，不如因而厚遇之，使歸趙，趙王豈以一璧之故欺秦邪！」卒廷見相如，畢禮而歸之。相如既歸，趙王以為賢大夫，使不辱於諸侯，拜相如為上大夫。秦亦不以城予趙，趙亦終不予秦璧。

其後秦伐趙，拔石城。明年，復攻趙，殺二萬人。

秦王使使者告趙王，欲與王為好會於西河外澠池。趙王畏秦，欲毋行。廉頗、藺相如計曰：「王不行，示趙弱且怯也。」趙王遂行，相如從。廉頗送至境，與王訣曰：「王行，度道里會遇之禮畢，還，不過三十日。三十日不還，則請立太子為王，以絕秦望。」王許之，遂與秦王會澠池。

秦王飲酒酣，曰：「寡人竊聞趙王好音，請奏瑟。」趙王鼓瑟。秦御史前書曰：「某年月日，秦王與趙王會飲，令趙王鼓瑟。」藺相如前曰：「趙王竊聞秦王善為秦聲，請奏盆缻秦王，以相娛樂。」秦王怒，不許。於是相如前進缻，因跪請秦王。秦王不肯擊缻。相如曰：「五步之內，相如請得以頸血濺大王矣！」左右欲刃相如，相如張目叱之，左右皆靡。於是秦王不懌，為一擊缻。相如顧召趙御史書曰：「某年月日，秦王為趙王擊缻。」秦之羣臣曰：「請以趙十五城為秦王壽。」藺相如亦曰：「請以秦之咸陽為趙王壽。」秦王竟酒，終不能加勝於趙。趙亦盛設兵以待秦，秦不敢動。

既罷歸國，以相如功大，拜為上卿，位在廉頗之右。廉頗曰：「我為趙將，有攻城野戰之大功，而藺相如徒以口舌為勞，而位居我上，且相如素賤人，吾羞，不忍為之下。」宣言曰：「我見相如，必辱之。」相如聞，不肯與會。相如每朝時，常稱病，不欲與廉頗爭列。已而相如出，望見廉頗，相如引車避匿。

於是舍人相與諫曰：「臣所以去親戚而事君者，徒慕君之高義也。今君與廉頗同列，廉君宣惡言而君畏匿之，恐懼殊甚，且庸人尚羞之，況於將相乎！臣等不肖，請辭去。」藺相如固止之，曰：「公之視廉將軍孰與秦王？」曰：「不若也。」相如曰：「夫以秦王之威，而相如廷叱之，辱其羣臣，相如雖駑，獨畏廉將軍哉？顧吾念之，彊秦之所以不敢加兵於趙者，徒以吾兩人在也。今兩虎共鬥，其勢不俱生。吾所以為此者，以先國家之急而後私讎也。」廉頗聞之，肉袒負荊，因賓客至藺相如門謝罪。曰：「鄙賤之人，不知將軍寬之至此也。」卒相與驩，為刎頸之交。`,
    modernTranslation: `廉頗，是趙國的良將傑出將領。趙惠文王十六年，做了趙國的大將，領兵攻打齊國，大敗齊軍，奪取了陽晉，獲委任為上卿，以勇氣聞於諸侯在諸侯國之間憑着勇猛善戰而聞。藺相如，是趙國人。在趙國宦官頭領繆賢門下做食客。

趙惠文王在位時，得到楚國的和氏璧。秦昭王聽到這個消息，派人送信給趙王，表示願意用十五座城來換這塊璧玉。趙王跟大將軍廉頗和各大臣商議：想把玉璧給秦國，又恐怕秦國的城池得不到手，只是白白被欺騙；想要不給，又害怕秦國派兵來攻打。計策沒有議定，想找個人派到秦國去回覆這件事，卻找不到適當的人選。

宦官頭領繆賢說：「我的門下食客藺相如可以出使秦國。」趙王問道：「您怎麼知道他可以擔當呢？」繆賢回答說：「我曾經犯罪，私下打算想逃到燕國去，我的食客藺相如勸阻我，說：『您是怎樣知道燕王會收留您？』我告訴他說：『我曾經跟隨大王與燕王在邊境上會見，燕王私下握著我的手說「願和你結為朋友」。因此我便知道燕王會收留我，所以想去燕國。』相如對我說：『趙國強大，燕國弱小，那時您又被趙王寵信，所以燕王才想和您結交。現在您卻是從趙國逃到燕國，燕國害怕趙國，從形勢來看必定不敢收留您，反而會把您綁起來送回趙國呢！您不如脫去上衣，裸露肩膊，伏在刑具上自請處罰，或許會僥倖得到免罪。』我聽從了他的建議，幸而大王亦赦免了我。我個人認為這人是個勇士，有智謀，應該可以擔任這個職務。

於是趙王召見藺相如，問他說：「秦王用十五座城來要求換取我的和氏璧，可不可以給他呢？」相如說：「秦國強而趙國弱，不可以不答應。」趙王說：「要是秦王拿了我的玉璧，卻不給我城池，那怎麼辦？」相如說：「秦國用城池來換璧而趙國不答應，理虧的是趙國；趙國送上玉璧而秦國不給趙國城池，理虧的是秦國。衡量這兩個對策，寧可答應秦國讓它負上理虧的責任。」趙王說：「誰人可以派去出使秦國？」相如說：「大王如果沒有適當的人選，我願意捧著玉璧前去出使。要是秦城劃入趙國的版圖，我就讓玉璧留在秦國；要是秦城不劃歸趙國，請讓我將玉璧完完整整的帶回趙國。」趙王於是派藺相如帶著和氏璧西行到秦國去。

秦王坐在章臺上接見藺相如，相如捧著璧獻給秦王。秦王十分高興，把玉璧傳給妃嬪和左右侍臣觀看，侍臣都高呼萬歲。相如看出秦王沒有誠意給趙國城池，於是上前說：「這玉璧上有瑕疵，請讓我指給大王看。」秦王將玉璧交給相如，相如就拿著玉璧退後幾步站定，靠著柱，憤怒得頭髮豎起了來頂著帽子，對秦王說：「大王想要得到這塊和氏璧，派人送信給趙王 ），召集全部大臣商量這件事，他們都說：『秦王很貪心，恃着國力強大，用空話來求取璧玉，恐怕是得不到秦國用城來酬答的。』商議不打算把玉璧送給秦國。我以為就算一般平民交往尚且不會互相欺騙，何況是堂堂大國呢？況且為了一塊玉璧的緣故，損害了與強大的秦國的友好關係，是不可以的。於是趙王齋戒了五天，差使我捧著玉璧，在朝廷上行叩拜大禮後才送出國書。為甚麼這樣做？因為尊重你大國的威望而表示敬意啊！現在我來到秦國，大王只在普通的台觀接見我，禮節十分傲慢；得到玉璧，又傳給妃嬪觀看，這樣來戲弄我。我看出大王沒有意思把城池給予趙王，所以我取回璧玉。如果大王一定要威逼我，我的頭顱今天就跟玉璧一起撞碎在柱子上吧！」

相如拿著玉璧斜視柱子，想把玉璧往柱子上撞。秦王怕他摔破玉璧，於是道歉，堅決請求他不要這樣做；又召來主管疆域圖的官員查看地圖，指出從這兒到那兒的十五座城劃給趙國。相如估計秦王不過是用欺詐的手段，假裝要把城給趙國，實際上是得不到的。於是對秦王說：「和氏璧，是天下人所公認的寶物。趙王懼怕秦國，不敢不獻上和氏璧。趙王送出這塊玉璧的時候，齋戒了五天，現在大王也應該齋戒五天，在朝廷上設置九賓的隆重禮節，我才敢獻上玉璧。」秦王估量一下，知道終究不可以強搶，於是答應斋戒五天，安置相如在廣成賓館。相如心想秦王雖然答應齋戒，但一定違約不給城池，便差遣他的隨從穿著粗布衣服，懷中藏著玉璧，從小路逃走，把玉璧送回趙國。

秦王齋戒五日後，便在朝廷上安排了九賓大禮，傳令請趙國的使者藺相如來見。相如來到殿上，對秦王說：「秦國自繆公以來的二十多位君主，從沒有一個是堅守信約的，我實在恐怕被大王欺騙而對不起趙國，所以派人把玉璧送回去，循小路回趙國了。再者秦國強，趙國弱，大王只須派一個使者到趙國，趙國就馬上把玉璧送來。現在憑秦國的強大並且先割十五座城給趙國，趙國怎敢留著玉璧而得罪大王呢？我知道欺騙大王罪該處死，我請求接受烹煮的刑罰。希望大王和大臣們仔細商議一下。」

秦王跟各大臣互相對望，發出既驚且怒的聲音。侍衛中有人想把相如拉出去治罪，秦王隨即說：「現在殺了相如，終究還是得不到玉璧，反而斷絕了秦、趙兩國的友好關係，倒不如趁這機會優厚地款待他，讓他返回趙國。趙王又怎會因一塊玉璧的緣故而欺騙秦國呢！」終於在朝廷上接見相如，完成了外交禮節，然後送他回國。相如回趙國後，趙王認為他勝過一般大夫，出使能不受諸侯欺辱，任命相如做上大夫。結果秦國沒有把城池劃給趙國，趙國最終也沒有把玉璧送給秦國。結果秦國沒有把城池劃給趙國，趙國最終也沒有把玉璧送給秦國。

後來秦國攻打趙國，奪取了石城。第二年，再攻打趙國，殺了兩萬人。

秦王派遣使者告訴趙王，想要跟趙王在西河外澠池作一次友好的會面。趙王害怕秦國，想不前往。廉頗和藺相如商量後說：「大王不去，顯得趙國軟弱而且膽怯。」趙王於是出發，相如隨行。廉頗送他們到邊境上，跟趙王告別 說：「大王這次上路，估計前往路程和會見的禮節完畢，加上回程，不會超過三十天。要是過了三十天還不回來，就請允許我們擁立太子為王，以斷絕秦國要脅的野心。」趙王答應了，於是跟秦王在澠池相會。

秦王喝酒喝得很高興，說：「我私下聽聞趙王愛好音樂，請你彈奏瑟。」趙王奏瑟。秦國的史官上前來記載道：「某年某月某日，秦王跟趙王一起喝酒，命令趙王彈瑟。」藺相如上前說：「趙王私下聽聞秦王善於演奏秦國的音樂，請允許我呈獻瓦盆給大王表演，好讓大家娛樂。」秦王大怒，不肯答應。於是相如上前去呈獻瓦盆 ，順勢跪下請求秦王。秦王不肯敲打瓦盆。相如說：「五步之內，我相如可要用頸上的血濺到大王身上了！」秦王的侍衛想用刀殺相如。相如瞪大眼睛叱喝他們，侍衛都嚇得向後退。於是秦王很不高興，勉強敲打了瓦盆一下。相如回頭召喚趙國史官寫下：「某年某月某日，秦王為趙王敲瓦盆。」秦國的大臣們說：「請把趙國十五座城送給秦王作為獻禮。」藺相如也說：「請把秦國的首都咸陽送給趙王作為獻禮。」秦王直到酒宴完畢，始終不能佔趙國的上風。趙國也大規模集結軍隊來防範秦國，秦國不敢妄動。

會談完畢回到趙國，趙王認為藺相如功勞很大，封他為上卿，地位在廉頗之上。廉頗說：「我身為趙國大將，有攻取城池血戰曠野的大功，藺相如只不過憑說幾句話立了功勞，而位職位竟在我之上。況且相如本來是個出身微賤的人，我真感到羞辱，不能忍受屈居他之下。」公開揚言說：「我如果遇見相如，一定羞辱他 ！」相如聽到這些話，就不肯跟廉頗見面。相如每逢上朝的時候，總是推說有病，不願意與廉頗爭位次的先後。後來相如外出，遠遠望見廉頗來了，趕忙吩咐車夫掉轉車迴避廉頗。

於是藺相如的門下食客都來進諫說：「我們之所以離開家人親戚前來侍奉您，只不過仰慕您崇高的品德。現在您跟廉頗職位相同，那位廉將軍公開說出惡意的話，而你卻害怕得躲避他，恐懼得太過分了。就算是一個普通人也會感到羞恥，何況是將相呢？我們沒有用，請讓我們告辭吧！」藺相如堅決挽留他們，說：「你們看廉將軍跟秦王比較哪一個厲害呢？」答道：「廉頗比不上秦王。」相如說：「就以秦王的威勢，我也敢在朝廷叱喝他，折辱他的大臣們；我雖然愚鈍，難道就單單害怕廉將軍嗎？但我考慮到，強暴的秦國之所以不敢出兵攻打趙國，就是因為有我和廉將軍兩個人在。現在兩虎相鬥，勢必不能共存。我所以這樣做，是把國家的危急放在前而把個人恩怨放在次要位置啊！」廉頗聽到這些話 ，就解衣露膊，背著荊條，由賓客引領到藺相如家門前道歉請求責罰。說：「我這個沒有見識的粗人，不知道將軍寬大待我到這個地步啊！」結果兩人和好，成為同生共死的好朋友。`
  },

  // C2. 孟子《魚我所欲也》
  'hkdse-c2-mengzi-fish-desire': {
    id: 'hkdse-c2-mengzi-fish-desire',
    title: '孟子《魚我所欲也》',
    author: '孟子',
    dynasty: '戰國',
    category: 'C2',
    type: 'C',
    originalText: `孟子曰：「魚，我所欲也，熊掌，亦我所欲也；二者不可得兼，舍魚而取熊掌者也。生亦我所欲也，義亦我所欲也；二者不可得兼，舍生而取義者也。生亦我所欲，所欲有甚於生者，故不為苟得也；死亦我所惡，所惡有甚於死者，故患有所不辟也。如使人之所欲莫甚於生，則凡可以得生者，何不用也？使人之所惡莫甚於死者，則凡可以辟患者，何不為也？由是則生而有不用也，由是則可以辟患而有不為也，是故所欲有甚於生者，所惡有甚於死者。非獨賢者有是心也，人皆有之，賢者能勿喪耳。

一簞食，一豆羹，得之則生，弗得則死。嘑爾而與之，行道之人弗受；蹴爾而與之，乞人不屑也；萬鍾則不辯禮義而受之。萬鍾於我何加焉？為宮室之美、妻妾之奉、所識窮乏者得我與？鄉為身死而不受，今為宮室之美為之；鄉為身死而不受，今為妻妾之奉為之；鄉為身死而不受，今為所識窮乏者得我而為之，是亦不可以已乎？此之謂失其本心。」`,
    modernTranslation: `孟子說：「魚，是我想要的；熊掌，也是我想要的。如果兩者不能同時擁有，我就捨棄魚而選擇熊掌。生命，也是我想要的；大義，也是我想要的。如果兩者不能同時擁有，我就捨棄生命而選擇大義。

生命是我想要的，然而我想要的東西還有比生命更為重要的，所以我不會苟且偷生。死亡是我厭惡的，然而我厭惡的事情還有比死亡更討厭的，所以有的禍害我就不躲避。如果人們喜愛的東西沒有比生命更重要的，那麼凡是可求得生存的方法，為甚麼不使用呢？如果人們厭惡的事情沒有被死亡更討厭的，那麼凡是可以躲避禍害的手段，為甚麼不去做呢？憑這些方法就可以生存，有人卻不用；憑這些方法就可以躲避禍患，有人卻不願意這樣做。

因此（可以證明）人們所想要的東西有比生命更重要的，人們厭惡的事情有比死亡更討厭的。不僅僅賢人有這種本性，人人都有這種本性，只不過賢人能夠保存這種本性不喪失罷了。

一筐飯，一碗湯，得到便可以活下去，失去它就要死亡。呼喝着把食物給人吃，流浪者不會接受；踐踏後給人吃，乞丐也不屑接受；為了優厚的俸祿，不分辨是否合於禮義就接受。

這優厚的俸祿對我有甚麼好處呢？為了住宅的華美、妻妾的侍奉，為了我認識的貧困者得到我的恩惠並感激我嗎？對於這些不合禮義的東西過去寧願犧牲自己的生命都不接受，現在卻為了華美的居室而接受了；過去寧願犧牲自己的生命都不接受，現在卻為了妻妾的侍奉而接受了；以往寧願犧牲自己的生命都不接受，現在卻為了我所認識的貧困者感激我而接受了，這些做法不能停止嗎？這就是說喪失了人的本性。」`
  },

  // C3. 荀子《勸學》（節錄）
  'hkdse-c3-xunzi-learning-encouragement': {
    id: 'hkdse-c3-xunzi-learning-encouragement',
    title: '荀子《勸學》（節錄）',
    author: '荀子',
    dynasty: '戰國',
    category: 'C3',
    type: 'C',
    originalText: `君子曰：學不可以已。青，取之於藍，而青於藍；冰，水為之，而寒於水。木直中繩，輮以為輪，其曲中規；雖有槁暴，不復挺者，輮使之然也。故木受繩則直，金就礪則利，君子博學而日參省乎己，則知明而行無過矣。

吾嘗終日而思矣，不如須臾之所學也；吾嘗跂而望矣，不如登高之博見也。登高而招，臂非加長也，而見者遠。順風而呼，聲非加疾也，而聞者彰。假輿馬者，非利足也，而致千里；假舟楫者，非能水也，而絕江河。君子生非異也，善假於物也。

積土成山，風雨興焉；積水成淵，蛟龍生焉；積善成德，而神明自得，聖心備焉。故不積跬步，無以至千里；不積小流，無以成江海。騏驥一躍，不能十步；駑馬十駕，功在不舍。鍥而舍之，朽木不折；鍥而不舍，金石可鏤。螾無爪牙之利，筋骨之強，上食埃土，下飲黃泉，用心一也。蟹六跪而二螯，非蛇蟺之穴無可寄託者，用心躁也。`,
    modernTranslation: `君子說：求學是不可以停止的。青這種顏色是由藍草提煉出來的，卻比藍草更青；冰是由水凝結而成的，卻比水更冷。木材挺直得合於繩墨的標準，經過火烤加工製成車輪，它彎曲的程度便合於圓規的標準，即使再度將它火烘、曝曬，也不會回復挺直，這是輮曲的工夫使它變成這個樣子。所以木材經過繩墨矯正就會筆直，刀劍經過磨礪就會鋒利；君子廣泛學習不同知識，而且每天再三反省自身言行，就能智慧高明，行為沒有過失了。

我曾經整天深思，卻不如片刻時間的學習得到的多；我曾經提起腳跟望向遠方，卻不如登上高處看得廣闊。登上高處招手，手臂並沒增長，卻能讓更遠的人看到；順著風呼叫，聲音並無特別宏亮，而卻能讓人聽得更清楚。乘駕車馬的人，並不是善於行走，卻能夠遠行千里；搭乘舟船的人，並不是善於游水，卻能橫渡江河。君子天性和一般人沒有什麼不同，只是善於利用後天所學罷了。

累積泥土成為高山，自然就會興起風雨；累積流水而成為深淵，自然就會生出蛟龍；累積善行而養成美德，自然就會達到心智澄明的境界，具備聖人的修養。所以不一步一步的累積，是無法到達千里之遠的；不匯聚一條一條的小水流，就無法成為江海。駿馬一個跳躍，不能跳出十步遠；劣馬連走十天的行程，也能到達千里，牠的成功在於牠不放棄。雕刻時若半途而廢，就是已經朽爛的木頭也無法折斷；假若持之以恆，就是金屬石頭也可加以雕飾。蚯蚓沒有銳利的爪牙，沒有強勁的筋骨，卻可以往上鑽食土壤，往下啜飲地泉，因為牠用心專一。螃蟹雖然有六隻腳兩隻大鉗子，但沒有蛇或鱔的洞穴，就無處藏身了，這是因為牠心思浮躁的緣故。`
  },

  // C4. 蘇洵《六國論》
  'hkdse-c4-suxun-six-states-theory': {
    id: 'hkdse-c4-suxun-six-states-theory',
    title: '蘇洵《六國論》',
    author: '蘇洵',
    dynasty: '宋',
    category: 'C4',
    type: 'C',
    originalText: `六國破滅，非兵不利，戰不善，弊在賂秦。賂秦而力虧，破滅之道也。或曰：「六國互喪，率賂秦耶？」曰：「不賂者以賂者喪。」蓋失強援，不能獨完，故曰「弊在賂秦」也。

秦以攻取之外，小則獲邑，大則得城，較秦之所得與戰勝而得者，其實百倍；諸侯之所亡與戰敗而亡者，其實亦百倍。則秦之所大欲，諸侯之所大患，固不在戰矣。思厥先祖父，暴霜露，斬荊棘，以有尺寸之地。子孫視之不甚惜，舉以予人，如棄草芥。今日割五城，明日割十城，然後得一夕安寢；起視四境，而秦兵又至矣。然則諸侯之地有限，暴秦之欲無厭，奉之彌繁，侵之愈急，故不戰而強弱勝負已判矣。至於顛覆，理固宜然。古人云：「以地事秦，猶抱薪救火，薪不盡，火不滅。」此言得之。

齊人未嘗賂秦，終繼五國遷滅，何哉？與嬴而不助五國也。五國既喪，齊亦不免矣。燕趙之君，始有遠略，能守其土，義不賂秦。是故燕雖小國而後亡，斯用兵之效也。至丹以荊卿為計，始速禍焉。趙嘗五戰于秦，二敗而三勝；後秦擊趙者再，李牧連卻之；洎牧以讒誅，邯鄲為郡，惜其用武而不終也。且燕趙處秦革滅殆盡之際，可謂智力孤危，戰敗而亡，誠不得已。向使三國各愛其地，齊人勿附於秦，刺客不行，良將猶在，則勝負之數，存亡之理，當與秦相較，或未易量。

嗚呼！以賂秦之地，封天下之謀臣；以事秦之心，禮天下之奇才；并力西嚮，則吾恐秦人食之不得下嚥也。悲夫！有如此之勢，而為秦人積威之所劫，日削月割，以趨於亡！為國者無使為積威之所劫哉！

夫六國與秦皆諸侯，其勢弱於秦，而猶有可以不賂而勝之之勢；茍以天下之大，而從六國破亡之故事，是又在六國下矣！`,
    modernTranslation: `六個諸侯國的滅亡，不是（因為他們的）武器不鋒利，仗打得不好，弊病在於（用土地來）賄賂秦國。（用土地）賄賂秦國而（自己的）國力被損耗，（這就）是滅亡的原因。有人說：「六國交接地滅亡，（難道）都是因為賄賂秦國嗎？」（回答）說：「不賄賂秦國的國家因為有賄賂秦國的國家而滅亡。原因是（不賄賂秦國的國家）失去強大的援助，不能獨自保全，所以說：「弊病在於賄賂秦國」。

秦國除了藉戰爭奪取土地以外，（還受到諸侯的賄賂），（收穫）小的就獲得邑鎮，（收穫）大的就獲得城池，比較秦國（受賄賂）所得到的土地與戰勝別國所得到的土地，（前者）實際多百倍；六國諸侯（賄賂秦國）所喪失的土地與戰敗所喪失的土地（相比），（前者）實際也要多百倍。那麼秦國最想要的，與六國諸侯最擔心的，本來就不在於戰爭。想到他們的祖輩和父輩，暴露於寒霜雨露（之下），披荊斬棘，才有了很少的一點土地。子孫對那些土地卻不很愛惜，全都拿來送給別人，就像扔掉小草一樣（不珍惜）。今天捨棄五座城，明天捨棄十座城，然後能睡一夜安穩覺；（翌日）起牀一看四周邊境，秦國的軍隊又來了。既然這樣，那麼諸侯的土地有限，強暴的秦國的慾望不會滿足，（諸侯）送給他的土地越多，他侵犯諸侯國土就越急迫，所以用不着戰爭，誰強誰弱，誰勝誰負已經分明了。到了覆滅的地步，道理本來應當這樣。古人說：「用土地侍奉秦國，好像抱著柴救火，柴不燒完，火就不會滅。」這話說出其中道理。

齊國不曾賄賂秦國，（可是）最終也隨着五國滅亡，為什麼呢？（是因為齊國）跟秦國交好卻不幫助其他五國。五國已經滅亡，齊國也沒法幸免了。燕國和趙國的國君，起初有長遠的謀略，能夠守住他們的國土，以不賄賂秦國為原則。因此燕雖然是個小國，卻後來才滅亡，這就是作戰抗秦的效果。等到燕太子丹用（派遣）荊軻（刺殺秦王）作（對付秦國的）計策，才招致（滅亡的）禍患。趙國曾經與秦國交戰五次，打了兩次敗仗、三次勝仗；後來秦國兩次攻打趙國。（趙國大將）李牧接連擊退秦軍；等到李牧因（他人的）讒言而被誅殺，（趙國都城）邯鄲變成（秦國的一個）郡，可惜趙國用武力（抗秦）卻沒有（堅持）到底。而且燕趙兩國處在秦國把其他國家快要消滅乾淨的時候，可以說是智謀與勇力都處孤立艱危（的狀態），戰敗了而亡國，確實是無可奈何的事。假使韓、魏、楚三國都愛惜他們的國土，齊國不依附秦國。（燕國）不用刺客（刺秦王之計），（趙國的）良將李牧仍然活着，那麼勝敗的命運，存亡的理數，倘若和秦國相互比較，也許（還）不容易衡量（出高低）。

唉！（如果六國諸侯）用賄賂秦國的土地，分封給天下間有謀略的臣子；用侍奉秦國的心，禮遇天下間才智出眾的人；合力向西（對付秦國），那麼，我恐怕秦國人飯也不能嚥下去。真可悲啊！有這樣的（有利）形勢，卻被秦國久積的威勢所威脅，天天割地，月月割地，以至於走向滅亡！治理國家的人無須被久積的威勢所威脅啊！

六國和秦國都是諸侯之國，六國的勢力比秦國弱，卻仍然有可以不賄賂秦國而戰勝它的優勢；如果憑藉偌大的國家，卻追隨六國滅亡的前例，這就比不上六國了！`
  },

  // C5. 莊子《逍遙遊》
  'hkdse-c5-zhuangzi-freedom-wandering': {
    id: 'hkdse-c5-zhuangzi-freedom-wandering',
    title: '莊子《逍遙遊》',
    author: '莊子',
    dynasty: '戰國',
    category: 'C5',
    type: 'C',
    originalText: `惠子謂莊子曰：「魏王貽我大瓠之種，我樹之成而實五石。以盛水漿，其堅不能自舉也。剖之以為瓢，則瓠落無所容。非不呺然大也，吾為其無用而掊之。」莊子曰：「夫子固拙於用大矣！宋人有善為不龜手之藥者，世世以洴澼絖為事。客聞之，請買其方百金。聚族而謀曰：『我世世為洴澼絖，不過數金；今一朝而鬻技百金，請與之。』客得之，以說吳王。越有難，吳王使之將，冬與越人水戰，大敗越人，裂地而封之。能不龜手一也；或以封，或不免於洴澼絖，則所用之異也。今子有五石之瓠，何不慮以為大樽而浮於江湖，而憂其瓠落無所容，則夫子猶有蓬之心也夫！」

惠子謂莊子曰：「吾有大樹，人謂之樗；其大本擁腫而不中繩墨，其小枝卷曲而不中規矩。立之塗，匠者不顧。今子之言，大而無用，衆所同去也。」莊子曰：「子獨不見狸狌乎？卑身而伏，以候敖者；東西跳梁，不辟高下，中於機辟，死於罔罟。今夫斄牛，其大若垂天之雲；此能為大矣，而不能執鼠。今子有大樹，患其無用，何不樹之於無何有之鄉，廣莫之野，彷徨乎無為其側，逍遙乎寢臥其下，不夭斤斧，物無害者。無所可用，安所困苦哉？」`,
    modernTranslation: `惠子對莊子說：「魏王送我大葫蘆的種子，我種植它成長，果實足有五石之大；用它來盛水，它的堅固程度卻不能承受起自身的重量；剖開它為瓢，則瓢大而無處可容。這葫蘆不是不大，但我認為它沒有用處，就把它打破了。」莊子說：「你實在不善於用『大』啊！有個宋國人善於製造不龜裂手的秘藥，他家世世代代都以漂洗絲絮為事業。有個客人聽聞此事，願出百金來買他的藥方。於是他便聚合家人商議說：『我們世世代代漂洗絲絮，只不過得到數金；如今一旦賣出這個藥方就可獲得百金，就賣了吧。』客人得到了藥方，便去遊說吳王。這時越國又來侵吳，吳王就派他將兵，在冬天與越軍水戰，結果大敗越軍，便割地封賞他。同樣一個不龜裂手的藥方，有人因此得到封賞，有人卻只用來漂洗絲絮，那就是所用方法的不同啊。如今你有五石容量的大葫蘆，為何不考慮將它當腰舟而浮游於江湖之上，反而擔憂它太大而無處可容呢？可見你的心還是茅塞不通啊！」

惠子對莊子說：「我有一棵大樹，人家都叫它臭椿樹。它的樹幹臃腫而不合墨線，它的小枝彎曲而不合規矩，長在路邊，木匠也不會回首一看。現在你的言論，大而無用，大家都會離棄啊。」莊子說：「你難道沒見過野貓和黃鼠狼嗎？牠們卑伏身子，等待出遊的小動物；東跳西躍，不避高低，往往踏中機關，死於網中。再看看那牦牛，身體大得像天邊的雲，牠的功能是很大，但卻連捕鼠也不能。現在你有這麼一棵大樹，還愁它沒有用處，為何不把它種在寬曠無人的鄉間、廣闊無邊的原野，寫意無憂地在樹旁閑逛，優遊自得地在樹下躺臥？它不會受斧頭砍伐，又沒有東西來毀害它，沒有用處，又有甚麼困苦呢？」`
  },
  // D1. 范仲淹《岳陽樓記》
  'hkdse-d1-fanzhongyan-yueyanglou-ji': {
    id: 'hkdse-d1-fanzhongyan-yueyanglou-ji',
    title: '范仲淹《岳陽樓記》',
    author: '范仲淹',
    dynasty: '宋',
    category: 'D1',
    type: 'D',
    originalText: `慶曆四年春，滕子京謫守巴陵郡。越明年，政通人和，百廢具興。乃重修岳陽樓，增其舊制，刻唐賢今人詩賦於其上。屬予作文以記之。

予觀夫巴陵勝狀，在洞庭一湖。銜遠山，吞長江，浩浩湯湯，橫無際涯；朝暉夕陰，氣象萬千。此則岳陽樓之大觀也，前人之述備矣。然則北通巫峽，南極瀟湘，遷客騷人，多會於此，覽物之情，得無異乎？

若夫霪雨霏霏，連月不開，陰風怒號，濁浪排空；日星隱曜，山岳潛形；商旅不行，檣傾楫摧；薄暮冥冥，虎嘯猿啼。登斯樓也，則有去國懷鄉，憂讒畏譏，滿目蕭然，感極而悲者矣。

至若春和景明，波瀾不驚，上下天光，一碧萬頃；沙鷗翔集，錦鱗游泳；岸芷汀蘭，郁郁青青。而或長煙一空，皓月千里，浮光躍金，靜影沉璧，漁歌互答，此樂何極！登斯樓也，則有心曠神怡，寵辱偕忘，把酒臨風，其喜洋洋者矣。

嗟夫！予嘗求古仁人之心，或異二者之為，何哉？不以物喜，不以己悲；居廟堂之高則憂其民，處江湖之遠則憂其君。是進亦憂，退亦憂。然則何時而樂耶？其必曰「先天下之憂而憂，後天下之樂而樂」乎。噫！微斯人，吾誰與歸？

時六年九月十五日。`,
    modernTranslation: `慶曆四年的春天，滕子京被貶官到巴陵郡做太守。到了第二年，政事順利，百姓和樂，各種荒廢的事業都興辦起來了。於是重新修建岳陽樓，擴展它舊有的規模，把唐代名家和當今人的詩賦刻在上面。囑託我寫一篇文章來記述這件事。

我看那巴陵郡的美好景色，全在洞庭湖上。它連接著遠處的山，吞吐著長江的水流，浩浩蕩蕩，無邊無際，清晨陽光明媚，傍晚陰暗，景象千變萬化。這就是岳陽樓雄偉壯觀的景象，前人的記述（已經）很詳盡了。雖然如此，那麼向北面通到巫峽，向南面直到瀟水和湘水，降職的官吏和來往的詩人，大多在這裡聚會，（他們）觀賞自然景物而觸發的感情大概會有所不同吧？

像那陰雨連綿，接連幾個月不放晴，寒風怒吼，渾濁的浪衝向天空；太陽和星星隱藏起光輝，山岳隱沒了形體；商人和旅客（一譯：行商和客商）不能通行，船桿倒下，船槳折斷；傍晚天色昏暗，虎在長嘯，猿在悲啼，（這時）登上這座樓啊，就會有一種離開國都、懷念家鄉，擔心人家說壞話、懼怕人家批評指責，滿眼都是蕭條的景象，感慨到了極點而悲傷的心情。

到了春風和煦、陽光明媚的時候，湖面平靜，沒有驚濤駭浪，天色湖光相接，一片碧綠，廣闊無際；沙洲上的鷗鳥，時而飛翔，時而停歇，美麗的魚游來游去，岸上的香草和小洲上的蘭花，草木茂盛，青翠欲滴。有時大片煙霧完全消散，皎潔的月光一瀉千里，照在湖面上閃著金色，月影映入水底，像沉潛的玉璧，漁夫的歌聲在你唱我和，這樣的樂趣（真是）無窮無盡！（這時）登上這座樓啊，就會感到心胸開闊、心情愉快，光榮和屈辱一併忘了，端著酒杯，吹著微風，那真是快樂高興極了。

唉！我曾經探求古時品德高尚的人的思想感情，或許不同於（以上）兩種人的心情，這是為什麼呢？（是由於）不因為外物好壞和自己得失而或喜或悲。在朝廷上做官時，就為百姓擔憂；在江湖上不做官時，就為國君擔憂。這樣來說在朝廷做官也擔憂，在僻遠的江湖也擔憂。既然這樣，那麼他們什麼時候才會感到快樂呢？他們一定會說：「在天下人憂之前先憂，在天下人樂之後才樂」。唉！沒有這種人，我同誰一道呢？

寫於慶曆六年九月十五日。`
  },

  // D2. 柳宗元《始得西山宴遊記》
  'hkdse-d2-liuzongyuan-xishan-yanyou-ji': {
    id: 'hkdse-d2-liuzongyuan-xishan-yanyou-ji',
    title: '柳宗元《始得西山宴遊記》',
    author: '柳宗元',
    dynasty: '唐',
    category: 'D2',
    type: 'D',
    originalText: `自余為僇人，居是州，恆惴慄。其隙也，則施施而行，漫漫而遊。日與其徒上高山，入深林，窮迴谿，幽泉怪石，無遠不到。到則披草而坐，傾壺而醉。醉則更相枕以臥，臥而夢。意有所極，夢亦同趣。覺而起，起而歸。以為凡是州之山水有異態者，皆我有也，而未始知西山之怪特。

今年九月二十八日，因坐法華西亭，望西山，始指異之。遂命僕人過湘江，緣染溪，斫榛莽，焚茅茷，窮山之高而上。攀援而登，箕踞而遨，則凡數州之土壤，皆在衽席之下。其高下之勢，岈然窪然，若垤若穴，尺寸千里，攢蹙累積，莫得遁隱。縈青繚白，外與天際，四望如一。然後知是山之特立，不與培塿為類，悠悠乎與顥氣俱，而莫得其涯；洋洋乎與造物者遊，而不知其所窮。引觴滿酌，頹然就醉，不知日之入。蒼然暮色，自遠而至，至無所見，而猶不欲歸。心凝形釋，與萬化冥合。然後知吾嚮之未始遊，遊於是乎始。故為之文以志。是歲，元和四年也。`,
    modernTranslation: `自從我成為被貶謫的人，居住在這個州，常常憂懼不安。在空閒的時候，就緩慢地行走，漫無目的地遊覽。每天與我的同伴登上高山，進入深林，走遍彎曲的溪流，幽深的泉水和奇特的石頭，沒有遠的地方不去的。到了就撥開草叢坐下，倒盡壺中的酒喝醉。醉了就互相枕著躺下，躺下就做夢。心裡想到哪裡，夢也就做到哪裡。睡醒了就起來，起來就回去。我以為凡是這個州有奇特形態的山水，都已被我遊覽過了，而未曾知道西山的奇特。

今年九月二十八日，因為坐在法華西亭，眺望西山，才開始指著它覺得它奇特。於是命令僕人渡過湘江，沿著染溪，砍伐雜草，焚燒茅草，直到山的高處才停止。攀援著登上山去，伸開兩腿坐下，隨意觀賞，那麼幾個州的土地，都在自己的坐席之下。那高高低低的形勢，山峰高聳，山谷凹陷，有的像小土堆，有的像洞穴；千里內外的景物近在眼前，種種景物聚集、縮攏在一塊，沒有能夠逃脫、隱藏的。縈繞著青山，繚繞著白雲，與遙遠的天際相接，環看四周，渾然一體。然後才知道這座山的卓然聳立，不與小丘同類，心神無窮無盡地與天地間的大氣融合，沒有誰知道它們的邊界；無邊無際，與大自然遊玩，不知道它們的盡頭。拿起酒杯來倒滿酒，頹然就醉，不知道太陽落山了。灰暗的暮色，從遠處而來，到了什麼也看不見了，卻還不想回家。心神凝住了，形體消散了，與萬物暗暗地融合為一體。然後才知道我以前的遊覽不能算做遊覽，真正的遊覽從這一次才開始。所以為這次遊覽寫了篇文章作為記述。這一年，是元和四年。`
  },
  // E1. 諸葛亮《出師表》
  'hkdse-e1-zhugeliang-chushibiao': {
    id: 'hkdse-e1-zhugeliang-chushibiao',
    title: '諸葛亮《出師表》',
    author: '諸葛亮',
    dynasty: '三國',
    category: 'E1',
    type: 'E',
    originalText: `臣亮言：先帝創業未半而中道崩殂，今天下三分，益州疲弊，此誠危急存亡之秋也。然侍衛之臣不懈於內，忠志之士忘身於外者，蓋追先帝之殊遇，欲報之於陛下也。誠宜開張聖聽，以光先帝遺德，恢弘志士之氣，不宜妄自菲薄，引喻失義，以塞忠諫之路也。

宮中府中，俱為一體，陟罰臧否，不宜異同。若有作姦犯科及為忠善者，宜付有司論其刑賞，以昭陛下平明之理，不宜偏私，使內外異法也。

侍中、侍郎郭攸之、費禕、董允等，此皆良實，志慮忠純，是以先帝簡拔以遺陛下。愚以為宮中之事，事無大小，悉以諮之，然後施行，必能裨補闕漏，有所廣益。

將軍向寵，性行淑均，曉暢軍事，試用於昔日，先帝稱之曰能，是以眾議舉寵為督。愚以為營中之事，悉以諮之，必能使行陣和睦，優劣得所。

親賢臣，遠小人，此先漢所以興隆也；親小人，遠賢臣，此後漢所以傾頹也。先帝在時，每與臣論此事，未嘗不嘆息痛恨於桓、靈也。侍中、尚書、長史、參軍，此悉貞良死節之臣，願陛下親之信之，則漢室之隆，可計日而待也。

臣本布衣，躬耕於南陽，苟全性命於亂世，不求聞達於諸侯。先帝不以臣卑鄙，猥自枉屈，三顧臣於草廬之中，諮臣以當世之事，由是感激，遂許先帝以驅馳。後值傾覆，受任於敗軍之際，奉命於危難之間，爾來二十有一年矣。

先帝知臣謹慎，故臨崩寄臣以大事也。受命以來，夙夜憂嘆，恐託付不效，以傷先帝之明，故五月渡瀘，深入不毛。今南方已定，兵甲已足，當獎率三軍，北定中原，庶竭駑鈍，攘除姦凶，興復漢室，還於舊都。此臣所以報先帝而忠陛下之職分也。至於斟酌損益，進盡忠言，則攸之、禕、允之任也。

願陛下託臣以討賊興復之效，不效，則治臣之罪，以告先帝之靈。若無興德之言，則責攸之、禕、允等之慢，以彰其咎；陛下亦宜自謀，以諮諏善道，察納雅言，深追先帝遺詔。臣不勝受恩感激。

今當遠離，臨表涕零，不知所言。`,
    modernTranslation: `臣諸葛亮上言：先帝開創統一大業還沒有完成一半，就中途去世了。現在天下分成三國，益州地區人力物力疲憊睏乏，這實在是危急存亡的時刻啊。但是侍衛大臣們在朝廷內毫不懈怠，忠誠有志的將士們在疆場上奮不顧身，大概是因為追念先帝對他們的特殊待遇，想要報答給陛下啊。陛下確實應該廣泛地聽取群臣的意見，來發揚光大先帝遺留下來的美德，振奮鼓舞志士們的勇氣，不應該隨便看輕自己，說一些不恰當的話，以致堵塞人們向您盡忠進諫的道路。

皇宮中和丞相府中，都是一個整體，提升、懲罰、表揚、批評，不應該因為在宮中或在府中而有所不同。如果有做壞事違犯科條法令以及盡忠辦好事的人，應該交給主管的官員判定他們受罰或者受賞，來顯示陛下公正嚴明的治理，不應該有偏袒私心，使宮內和朝廷刑賞之法不同。

侍中、侍郎郭攸之、費禕、董允等，這些都是善良誠實的人，他們的志向和心思忠誠無二，因此先帝把他們選拔出來留給陛下。我認為宮中的事情，事情無論大小，都拿來跟他們商量，然後實行，一定能夠彌補缺點和疏漏之處，得到更多的好處。

將軍向寵，性格品行善良公正，通曉軍事，過去任用的時候，先帝稱讚說他有才能，因此大家評議推舉他做中部督。我認為軍營中的事情，都拿來跟他商量，一定能夠使軍隊團結和睦，好的壞的各得其所。

親近賢臣，疏遠小人，這是先漢興盛發達的原因；親近小人，疏遠賢臣，這是後漢傾覆衰敗的原因。先帝在世時，每次跟我談論這些事情，沒有一次不對桓、靈二帝的作法感到痛心遺憾的。侍中、尚書、長史、參軍，這些人都是忠貞優秀、以死報國的大臣，希望陛下親近他們，信任他們，這樣漢朝的興盛，就為期不遠了。

我本來是個平民，在南陽親自耕種，在亂世中苟且保全性命，不希求在諸侯中聞達顯貴。先帝不因為我身份低微，見識短淺，降低身份委屈自己，三次到草廬中來拜訪我，向我詢問當代的大事，因此我深為感動，於是答應為先帝奔走效勞。後來遇到兵敗，在戰事失敗的時候我接受了任命，在危機患難期間我受到委任，從那時以來二十一年了。

先帝知道我做事謹慎，所以臨終時把國家大事託付給我。接受遺命以來，我日夜憂慮嘆息，唯恐託付給我的事沒有完成，有損於先帝的英明，因此五月渡過瀘水，深入到不毛之地。現在南方已經平定，兵器已經準備充足，應當勉勵三軍，率領他們北上平定中原，希望能夠竭盡我平庸的才能，剷除奸邪凶惡的敵人，振興恢復漢朝的基業，回到舊日的國都。這是我用來報答先帝，並盡忠於陛下的職責本分。至於考慮事情是否可行，毫無保留地向您提出忠誠的建議，那就是郭攸之、費禕、董允等人的責任了。

希望陛下把討伐曹魏興復漢室的任務託付給我，如果沒有完成，就治我的罪，來告慰先帝在天之靈。如果沒有發揚聖德的言論，就責備郭攸之、費禕、董允等人的怠慢，來揭示他們的過失；陛下也應該自己謀劃，徵詢治國的好辦法，明察並採納正確的意見，深切追念先帝的遺命。我受恩感激不盡。

現在正當離陛下遠行的時候，面對著奏章我眼淚直流，不知道自己說了些什麼。`
  },
  // F1. 唐詩三首
  'hkdse-f1-tangshi-sanzhou': {
    id: 'hkdse-f1-tangshi-sanzhou',
    title: '唐詩三首',
    author: '李白、杜甫、王維',
    dynasty: '唐',
    category: 'F1',
    type: 'F',
    originalText: `《將進酒》李白
君不見，黃河之水天上來，奔流到海不復回。
君不見，高堂明鏡悲白髮，朝如青絲暮成雪。
人生得意須盡歡，莫使金樽空對月。
天生我材必有用，千金散盡還復來。
烹羊宰牛且為樂，會須一飲三百杯。
岑夫子，丹丘生，將進酒，杯莫停。
與君歌一曲，請君為我傾耳聽。
鐘鼓饌玉不足貴，但願長醉不願醒。
古來聖賢皆寂寞，惟有飲者留其名。
陳王昔時宴平樂，斗酒十千恣歡謔。
主人何為言少錢，徑須沽取對君酌。
五花馬，千金裘，呼兒將出換美酒，與爾同銷萬古愁。

《登高》杜甫
風急天高猿嘯哀，渚清沙白鳥飛回。
無邊落木蕭蕭下，不盡長江滾滾來。
萬里悲秋常作客，百年多病獨登台。
艱難苦恨繁霜鬢，潦倒新停濁酒杯。

《山居秋暝》王維
空山新雨後，天氣晚來秋。
明月松間照，清泉石上流。
竹喧歸浣女，蓮動下漁舟。
隨意春芳歇，王孫自可留。`,
    modernTranslation: `《將進酒》李白
你難道看不見，黃河的水從天上奔流而下，一直流到大海不再回返。
你難道看不見，在高堂上對著明鏡悲嘆白髮，早晨還是青絲晚上就變成白雪。
人生得意時要盡情歡樂，不要讓金樽空對著明月。
天生我材必有用，千金散盡還會再來。
烹羊宰牛姑且作樂，應該痛飲三百杯。
岑夫子，丹丘生，請喝酒，杯不要停。
我為你唱一首歌，請你為我側耳聽。
鐘鼓美食不足珍貴，只願長醉不願醒。
自古以來聖賢都寂寞，只有飲酒者留下美名。
陳王從前在平樂宮宴飲，斗酒十千盡情歡樂。
主人為什麼說錢少，只管買酒來對飲。
五花馬，千金裘，叫兒子拿出去換美酒，與你一起消解萬古愁。

《登高》杜甫
風急天高猿猴哀叫，水清沙白鳥兒飛回。
無邊的落葉蕭蕭飄下，不盡的長江滾滾而來。
萬里悲秋常作客，百年多病獨登台。
艱難苦恨使雙鬢斑白，潦倒新停濁酒杯。

《山居秋暝》王維
空山新雨後，天氣晚來秋。
明月松間照，清泉石上流。
竹喧歸浣女，蓮動下漁舟。
隨意春芳歇，王孫自可留。`
  },

  // F2. 詞三首
  'hkdse-f2-ci-sanzhou': {
    id: 'hkdse-f2-ci-sanzhou',
    title: '詞三首',
    author: '李煜、蘇軾、辛棄疾',
    dynasty: '五代、宋',
    category: 'F2',
    type: 'F',
    originalText: `《虞美人》李煜
春花秋月何時了，往事知多少。
小樓昨夜又東風，故國不堪回首月明中。
雕欄玉砌應猶在，只是朱顏改。
問君能有幾多愁，恰似一江春水向東流。

《水調歌頭》蘇軾
明月幾時有，把酒問青天。
不知天上宮闕，今夕是何年。
我欲乘風歸去，又恐瓊樓玉宇，高處不勝寒。
起舞弄清影，何似在人間。
轉朱閣，低綺戶，照無眠。
不應有恨，何事長向別時圓。
人有悲歡離合，月有陰晴圓缺，此事古難全。
但願人長久，千里共嬋娟。

《破陣子》辛棄疾
醉裡挑燈看劍，夢回吹角連營。
八百里分麾下炙，五十弦翻塞外聲，沙場秋點兵。
馬作的盧飛快，弓如霹靂弦驚。
了卻君王天下事，贏得生前身後名，可憐白髮生。`,
    modernTranslation: `《虞美人》李煜
春花秋月何時了，往事知多少。
小樓昨夜又東風，故國不堪回首月明中。
雕欄玉砌應猶在，只是朱顏改。
問君能有幾多愁，恰似一江春水向東流。

《水調歌頭》蘇軾
明月幾時有，把酒問青天。
不知天上宮闕，今夕是何年。
我欲乘風歸去，又恐瓊樓玉宇，高處不勝寒。
起舞弄清影，何似在人間。
轉朱閣，低綺戶，照無眠。
不應有恨，何事長向別時圓。
人有悲歡離合，月有陰晴圓缺，此事古難全。
但願人長久，千里共嬋娟。

《破陣子》辛棄疾
醉裡挑燈看劍，夢回吹角連營。
八百里分麾下炙，五十弦翻塞外聲，沙場秋點兵。
馬作的盧飛快，弓如霹靂弦驚。
了卻君王天下事，贏得生前身後名，可憐白髮生。`
  }  
};

// Helper function to get original text by ID
export const getOriginalTextById = (textId) => {
  return hkdseOriginalTexts[textId] || null;
};

// Helper function to get all original texts
export const getAllOriginalTexts = () => {
  return Object.values(hkdseOriginalTexts);
}; 